module.exports = __webpack_public_path__ + "static/media/Mail.5aceaa06.png";